import React from "react";

/** Prefer shared Nyafaz mark used by kiosk PageFooter. */
const FOOTER_LOGO = `${process.env.PUBLIC_URL || ""}/footer.png`;

export default function PortalPoweredBy() {
  return (
    <footer className="portal-powered-by" aria-label="Powered by Nyafaz">
      <span className="portal-powered-by__label">Powered by</span>
      <a href="https://nyafaz.com/" target="_blank" rel="noopener noreferrer" aria-label="Visit Nyafaz website">
        <img
          src={FOOTER_LOGO}
          alt="Nyafaz"
          className="portal-powered-by__logo"
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      </a>
    </footer>
  );
}
